import React, { useState } from 'react'
import { View, TextInput, ViewStyle, TextStyle } from 'react-native'
import { observer } from 'mobx-react-lite'
import { Instance } from 'mobx-state-tree'

import { GameQuestion } from '@trivie/core/src/models/game/GameQuestion'
import { Branding } from '@trivie/core/src/models/Branding'

import { Button } from '../button'
import { color } from '../../theme/color'

interface OpenTextChoiceProps {
  question: Instance<typeof GameQuestion>
  branding: Instance<typeof Branding>
  style?: ViewStyle
  /** 'survey' disables correct/incorrect coloring (surveys are ungraded). */
  mode?: 'quiz' | 'survey'
}

export const OpenTextChoice = observer((props: OpenTextChoiceProps) => {
  const { question, branding, style = {}, mode = 'quiz' } = props
  const survey = mode === 'survey'

  const [input, setInput] = useState('')

  const handleSubmit = () => {
    question.setUserText(input.trim())
    if (question.answered) {
      return
    }
    question.answer()
  }

  const submitBtnStyle = {
    backgroundColor:
      !survey && question.answered
        ? question.answeredCorrectly
          ? branding.correct_answer
          : branding.incorrect_answer
        : branding.accent_color,
  }

  return (
    <View style={{ ...CONTAINER, ...style }} pointerEvents={question.answered ? 'none' : 'auto'}>
      <TextInput
        placeholder="Enter your answer here"
        onChangeText={(text) => setInput(text)}
        placeholderTextColor={`${branding.feedback_text}60`}
        style={{
          ...INPUT,
          backgroundColor: branding.feedback_background,
          borderColor:
            !survey && question.answered
              ? question.answeredCorrectly
                ? branding.correct_answer
                : branding.incorrect_answer
              : `${branding.text_color}40`,
          fontFamily: branding.font_family,
          color: branding.feedback_text,
        }}
        verticalAlign="middle"
        value={input}
        autoCapitalize="none"
        editable={!question.answered}
      />
      <Button
        style={submitBtnStyle}
        disabled={!input || !input.trim().length}
        styleOverrides={
          !input || !input.trim().length ? { backgroundColor: 'rgb(31,53,116)' } : submitBtnStyle
        }
        textStyle={{ color: color.white }}
        fullWidth
        tx="Common.submit"
        onPress={handleSubmit}
      />
    </View>
  )
})

const INPUT: TextStyle = {
  height: 52,
  borderRadius: 12,
  paddingHorizontal: 12,
  fontSize: 16,
  borderWidth: 1,
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: '500',
}
const CONTAINER: ViewStyle = {
  maxWidth: 800,
  width: '100%',
  alignSelf: 'center',
  gap: 16,
  justifyContent: 'flex-end',
}
